import { configureStore } from '@reduxjs/toolkit';
import counterReducer from './reducer/counterSlice';
import authReducer from './reducer/authSlice';
import calendarSlice from './reducer/calendarSlice';
import paidSearchSlice from './reducer/paidSearchSlice';
import overallPerformanceSlice from './reducer/overallPerformanceSlice';
import audienceAnalysisSlice from './reducer/audienceAnalysisSlice';
import channelOppsSlice from './reducer/channelOppsSlice';
import subBranchDashOppsByChannelSlice from './reducer/subBranchDashOppsByChannelSlice';
import overallPerformanceSubBranchSlice from './reducer/overallPerformanceSubBranch';
import performanceOverviewSubBranchSlice from './reducer/performanceOverviewSubBranch';

export default configureStore({
  reducer: {
    counter: counterReducer,
    auth: authReducer,
    calendar: calendarSlice,
    paidSearch: paidSearchSlice,
    overallPerformance: overallPerformanceSlice,
    audienceAnalysis: audienceAnalysisSlice,
    channelOpps: channelOppsSlice,
    subBranchDashOppsByChannel: subBranchDashOppsByChannelSlice,
    overallPerformanceSubBranch: overallPerformanceSubBranchSlice,
    performanceOverviewSubBranch: performanceOverviewSubBranchSlice,
  },
});
